import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './KitsSection.module.css';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import smoothScroll from '../../utils/smoothScroll';

// kitsData will now store keys or identifiers
const kitsKeyMap = [
    {
        key: 'retrofit',
        imgSrc: '/images/gg-hardware-cereal-sensor-kit-full.png',
        alt: 'Retrofit Kit for Cereals' // Alt text can be translated if needed by adding altKey
    },
    {
        key: 'canbus',
        imgSrc: '/images/gg-hardware-module-and-connector.png',
        alt: 'CANBUS Diagnostic Port Kit'
    },
    {
        key: 'potato',
        imgSrc: '/images/gg-hardware-potato-sensor-kit.png',
        alt: 'Retrofit Kit for Potatoes'
    }
];

const KitCard = ({ kitItemKey, imgSrc, alt }) => {
    const { t } = useTranslation();
    const cardRef = useScrollAnimation({ once: true });
    // Derive webp path
    const webpSrc = imgSrc.replace(/\.png$/, '.webp');
    return (
        <div className={`${styles.kitCard} animate-on-scroll`} ref={cardRef}>
            <picture>
                <source srcSet={webpSrc} type="image/webp" />
                <img src={imgSrc} alt={alt} loading="lazy" />
            </picture>
            <div className={styles.kitCardContent}>
                <h4>{t(`kits.kitItems.${kitItemKey}.title`)}</h4>
                <p>{t(`kits.kitItems.${kitItemKey}.description`)}</p>
            </div>
        </div>
    );
};

const KitsSection = () => {
    const { t } = useTranslation();
    const sectionRef = useScrollAnimation({ once: true });

    return (
        <section id="products" className="animate-on-scroll" ref={sectionRef}>
            <div className={`container ${styles.kitsContainer}`}> {/* Use container for padding */}
                <div className={styles.kitsHeader}>
                    <div className={styles.headerLeft}>
                        <img src={`${process.env.PUBLIC_URL}/images/squared_black.png`} alt="GG Logo" className={styles.ggLogoImage} />
                        <h2 className={`section-title ${styles.sectionTitle}`}>{t('kits.title')}</h2>
                    </div>
                    <div className={styles.headerRight}>
                        <a 
                            href="#cta-form" 
                            className={`btn ${styles.btnKnowMore}`}
                            onClick={(e) => smoothScroll(e, 'cta-form')}
                        >
                            {t('kits.knowMoreButton')}
                        </a>
                    </div>
                </div>
                <p className={styles.subtitle}>{t('kits.subtitle')}</p>
                <div className={styles.kitsGrid}>
                    {kitsKeyMap.map(kit => (
                        <KitCard key={kit.key} kitItemKey={kit.key} imgSrc={kit.imgSrc} alt={kit.alt} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default KitsSection;
